(() => {
  const SELECTOR = '[data-zv-pdf-open]';

  function initViewer(trigger) {
    if (trigger.dataset.zvPdfReady === 'true') return;
    trigger.dataset.zvPdfReady = 'true';

    trigger.addEventListener('click', (event) => {
      const supportsDialog = typeof HTMLDialogElement !== 'undefined';
      const useInlineViewer = window.matchMedia('(min-width: 768px)').matches;
      const dialog = document.getElementById(trigger.dataset.zvPdfOpen);

      if (!supportsDialog || !useInlineViewer || !dialog || typeof dialog.showModal !== 'function') return;

      event.preventDefault();
      const pdfUrl = trigger.href;
      const pdfTitle = trigger.dataset.zvPdfTitle || 'ZinVolt PDF';
      const frame = dialog.querySelector('[data-zv-pdf-frame]');
      const title = dialog.querySelector('.zv-pdf-dialog__header h2');
      const externalLink = dialog.querySelector('[data-zv-pdf-external]');
      if (title) title.textContent = pdfTitle;
      if (externalLink) externalLink.href = pdfUrl;
      if (frame) {
        frame.title = pdfTitle;
        if (frame.src !== pdfUrl) frame.src = pdfUrl;
      }
      dialog.showModal();
      dialog.querySelector('[data-zv-pdf-close]')?.focus();
    });
  }

  function init(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initViewer);
    root.querySelectorAll('[data-zv-pdf-dialog]').forEach((dialog) => {
      if (dialog.dataset.zvPdfDialogReady === 'true') return;
      dialog.dataset.zvPdfDialogReady = 'true';

      dialog.querySelector('[data-zv-pdf-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
